{
  "blue.1": "#f6f9ff",
  "blue.2": "#ebf3ff",
  "blue.3": "#c7daff",
  "blue.4": "#adc9ff",
  "blue.5": "#5599ff",
  "blue.6": "#105ed5",
  "blue.7": "#044ab4",
  "blue.8": "#13359d",
  "blue.9": "#002266",
  "blue.10": "#00113a",
  "purple.1": "#eae9ff",
  "purple.2": "#ddd7fc",
  "purple.3": "#cdbff9",
  "purple.4": "#b39aff",
  "purple.5": "#8e6afb",
  "purple.6": "#7447fc",
  "purple.7": "#6039d3",
  "purple.8": "#492ba0",
  "purple.9": "#291074",
  "purple.10": "#120338",
  "teal.1": "#ebf3f1",
  "teal.2": "#ceeee6",
  "teal.3": "#a7e6d7",
  "teal.4": "#58d7b9",
  "teal.5": "#31d0aa",
  "teal.6": "#26a889",
  "teal.7": "#23977b",
  "teal.8": "#1c7761",
  "teal.9": "#115746",
  "teal.10": "#002329",
  "green.1": "#eaf1ee",
  "green.2": "#e5f4ea",
  "green.3": "#c3e4ce",
  "green.4": "#95d4aa",
  "green.5": "#58af7c",
  "green.6": "#2f965d",
  "green.7": "#006733",
  "green.8": "#2c5840",
  "green.9": "#1e4630",
  "green.10": "#082800",
  "magenta.1": "#fff0f6",
  "magenta.2": "#ffd6e7",
  "magenta.3": "#ffadd2",
  "magenta.4": "#ff85c0",
  "magenta.5": "#f759ab",
  "magenta.6": "#eb2f96",
  "magenta.7": "#c41d7f",
  "magenta.8": "#9e1068",
  "magenta.9": "#780650",
  "magenta.10": "#520339",
  "red.1": "#fbeced",
  "red.2": "#f8d9da",
  "red.3": "#ebb8bb",
  "red.4": "#e46969",
  "red.5": "#db4552",
  "red.6": "#c23535",
  "red.7": "#9e2f34",
  "red.8": "#760521",
  "red.9": "#5b0117",
  "red.10": "#340005",
  "orange.1": "#fcfbf9",
  "orange.2": "#ffe6d9",
  "orange.3": "#f8d2b5",
  "orange.4": "#ffb066",
  "orange.5": "#fd8f52",
  "orange.6": "#de5731",
  "orange.7": "#cb4e01",
  "orange.8": "#b85722",
  "orange.9": "#75300a",
  "orange.10": "#39251b",
  "yellow.1": "#f6f5f3",
  "yellow.2": "#fff8e5",
  "yellow.3": "#fbeeca",
  "yellow.4": "#fce5a5",
  "yellow.5": "#fbdd73",
  "yellow.6": "#f9cc2d",
  "yellow.7": "#c29c00",
  "yellow.8": "#977b3c",
  "yellow.9": "#735502",
  "yellow.10": "#332118",
  "volcano.1": "#fff2e8",
  "volcano.2": "#ffd8bf",
  "volcano.3": "#ffbb96",
  "volcano.4": "#ff9c6e",
  "volcano.5": "#ff7a45",
  "volcano.6": "#fa541c",
  "volcano.7": "#d4380d",
  "volcano.8": "#ad2102",
  "volcano.9": "#871400",
  "volcano.10": "#610b00",
  "geekblue.1": "#f0f5ff",
  "geekblue.2": "#d6e4ff",
  "geekblue.3": "#adc6ff",
  "geekblue.4": "#85a5ff",
  "geekblue.5": "#597ef7",
  "geekblue.6": "#2f54eb",
  "geekblue.7": "#1d39c4",
  "geekblue.8": "#10239e",
  "geekblue.9": "#061178",
  "geekblue.10": "#030852",
  "lime.1": "#fcffe6",
  "lime.2": "#f4ffb8",
  "lime.3": "#eaff8f",
  "lime.4": "#d3f261",
  "lime.5": "#bae637",
  "lime.6": "#a0d911",
  "lime.7": "#7cb305",
  "lime.8": "#5b8c00",
  "lime.9": "#3f6600",
  "lime.10": "#254000",
  "gold.1": "#fffbe6",
  "gold.2": "#fff1b8",
  "gold.3": "#ffe58f",
  "gold.4": "#ffd666",
  "gold.5": "#ffc53d",
  "gold.6": "#faad14",
  "gold.7": "#d48806",
  "gold.8": "#ad6800",
  "gold.9": "#874d00",
  "gold.10": "#613400",
  "gray.1": "#fdfeff",
  "gray.2": "#fafafa",
  "gray.3": "#f8fafb",
  "gray.4": "#ececef",
  "gray.5": "#e4e6ec",
  "gray.6": "#bfbfc5",
  "gray.7": "#a2a3ad",
  "gray.8": "#6f6f76",
  "gray.9": "#515156",
  "gray.10": "#2e2e2e",
  "gray.20": "#242424",
  "gray.30": "#171718",
  "colorTextBase": "#2e2e2e",
  "colorTextLightSolid": "#fdfeff",
  "colorBgBase": "#fdfeff",
  "lineWidth": 1,
  "borderRadius": 8,
  "sizeUnit": 4,
  "sizePopupArrow": 16,
  "controlHeight": 32,
  "opacityImage": 1,
  "sizeStep": 4,
  "colorPrimary": "#105ed5",
  "colorError": "#c23535",
  "colorWarning": "#de5731",
  "colorSuccess": "#2f965d",
  "colorInfo": "#515156",
  "fontSize": 14,
  "size5XL": 64,
  "size4XL": 56,
  "size3XL": 48,
  "sizeXXL": 40,
  "sizeXL": 32,
  "sizeLG": 24,
  "sizeMD": 20,
  "sizeMS": 16,
  "size": 16,
  "sizeSM": 12,
  "sizeXS": 8,
  "sizeXXS": 4,
  "controlHeightXS": 16,
  "controlHeightSM": 24,
  "controlHeightLG": 40,
  "controlHeightXL": 48,
  "borderRadiusXS": 2,
  "borderRadiusSM": 4,
  "borderRadiusLG": 12,
  "borderRadiusXL": 24,
  "borderRadiusXXL": 32,
  "borderRadius3XL": 40,
  "borderRadius4XL": 48,
  "borderRadius5XL": 64,
  "borderRadiusOuter": 4,
  "colorText": "#2e2e2e",
  "colorTextSecondary": "rgba(46, 46, 46, 0.83)",
  "colorTextTertiary": "rgba(46, 46, 46, 0.7)",
  "colorTextQuaternary": "rgba(46, 46, 46, 0.44)",
  "colorFill": "rgba(46, 46, 46, 0.12)",
  "colorFillSecondary": "rgba(46, 46, 46, 0.08)",
  "colorFillTertiary": "rgba(46, 46, 46, 0.03)",
  "colorFillQuaternary": "rgba(46, 46, 46, 0.02)",
  "colorBgContainer": "#fdfeff",
  "colorBgLayout": "#fdfeff",
  "colorBgElevated": "#fdfeff",
  "colorBgSpotlight": "rgba(46, 46, 46, 0.85)",
  "colorBorder": "rgba(46, 46, 46, 0.83)",
  "colorBorderSecondary": "rgba(46, 46, 46, 0.29)",
  "colorBorderTertiary": "rgba(46, 46, 46, 0.13)",
  "colorBorderInverse": "#fdfeff",
  "colorSplit": "rgba(46, 46, 46, 0.83)",
  "colorSplitSecondary": "rgba(46, 46, 46, 0.29)",
  "colorSplitTertiary": "rgba(46, 46, 46, 0.13)",
  "colorPrimaryBg": "#f6f9ff",
  "colorPrimaryBgHover": "#ebf3ff",
  "colorPrimaryBorder": "#105ed5",
  "colorPrimaryBorderHover": "#044ab4",
  "colorPrimaryHover": "#044ab4",
  "colorPrimaryBase": "#105ed5",
  "colorPrimarySubdued": "#c7daff",
  "colorPrimarySubduedHover": "#adc9ff",
  "colorPrimarySubduedActive": "rgba(85, 153, 255, 0.7)",
  "colorPrimaryActive": "#13359d",
  "colorPrimaryTextHover": "#13359d",
  "colorPrimaryText": "#002266",
  "colorPrimaryTextActive": "#00113a",
  "colorSuccessBg": "#eaf1ee",
  "colorSuccessBgHover": "#e5f4ea",
  "colorSuccessBorder": "#2f965d",
  "colorSuccessBorderHover": "#006733",
  "colorSuccessHover": "#2c5840",
  "colorSuccessBase": "#2f965d",
  "colorSuccessVariant": "#006733",
  "colorSuccessSubdued": "#c3e4ce",
  "colorSuccessSubduedHover": "#95d4aa",
  "colorSuccessSubduedActive": "rgba(88, 175, 124, 0.75)",
  "colorSuccessActive": "#1e4630",
  "colorSuccessTextHover": "#2c5840",
  "colorSuccessText": "#1e4630",
  "colorSuccessTextActive": "#082800",
  "colorWarningBg": "#fcfbf9",
  "colorWarningBgHover": "#ffe6d9",
  "colorWarningBorder": "#de5731",
  "colorWarningBorderHover": "#cb4e01",
  "colorWarningHover": "#cb4e01",
  "colorWarningBase": "#de5731",
  "colorWarningSubdued": "#f8d2b5",
  "colorWarningSubduedHover": "rgba(255, 176, 102, 0.8)",
  "colorWarningSubduedActive": "rgba(253, 143, 82, 0.8)",
  "colorWarningActive": "#b85722",
  "colorWarningTextHover": "#b85722",
  "colorWarningText": "#75300a",
  "colorWarningTextActive": "#39251b",
  "colorErrorBg": "#fbeced",
  "colorErrorBgHover": "#f8d9da",
  "colorErrorBorder": "#c23535",
  "colorErrorBorderHover": "#9e2f34",
  "colorErrorHover": "#9e2f34",
  "colorErrorBase": "#c23535",
  "colorErrorSubdued": "#f8d9da",
  "colorErrorSubduedHover": "#ebb8bb",
  "colorErrorSubduedActive": "rgba(228, 105, 105, 0.7)",
  "colorErrorActive": "#760521",
  "colorErrorTextHover": "#760521",
  "colorErrorText": "#5b0117",
  "colorErrorTextActive": "#340005",
  "colorInfoBg": "#fafafa",
  "colorInfoBgHover": "#f8fafb",
  "colorInfoBorder": "#515156",
  "colorInfoBorderHover": "#2e2e2e",
  "colorInfoHover": "#2e2e2e",
  "colorInfoBase": "#515156",
  "colorInfoSubdued": "#e4e6ec",
  "colorInfoSubduedHover": "rgba(191, 191, 197, 0.8)",
  "colorInfoSubduedActive": "rgba(162, 163, 173, 0.8)",
  "colorInfoActive": "#242424",
  "colorInfoTextHover": "#6f6f76",
  "colorInfoText": "#515156",
  "colorInfoTextActive": "#2e2e2e",
  "colorBgMask": "rgba(46, 46, 46, 0.5)",
  "stepsDotSize": 8,
  "stepsCurrentDotSize": 10,
  "rateStarSize": 20,
  "colorFillContent": "rgba(46, 46, 46, 0.08)",
  "colorFillContentHover": "rgba(46, 46, 46, 0.12)",
  "colorFillAlter": "#f8fafb",
  "colorBgContainerDisabled": "rgba(46, 46, 46, 0.08)",
  "colorBgContainerDisabledSubdued": "rgba(46, 46, 46, 0.02)",
  "colorBorderBg": "#fdfeff",
  "colorTextPlaceholder": "rgba(46, 46, 46, 0.7)",
  "colorTextDisabled": "rgba(46, 46, 46, 0.44)",
  "colorTextHeading": "#2e2e2e",
  "colorTextLabel": "#2e2e2e",
  "colorTextDescription": "rgba(46, 46, 46, 0.7)",
  "colorBgTextHover": "#ededed",
  "colorBgTextActive": "#e0e0e0",
  "colorIcon": "rgba(46, 46, 46, 0.7)",
  "colorIconHover": "#2e2e2e",
  "colorLink": "#105ed5",
  "colorLinkHover": "#044ab4",
  "colorLinkActive": "#13359d",
  "colorHighlight": "#de5731",
  "controlOutline": "#f6f9ff",
  "colorWarningOutline": "#fcfbf9",
  "colorErrorOutline": "#fbeced",
  "fontSizeIcon": 12,
  "controlLineWidth": 1,
  "controlOutlineWidth": 2,
  "controlItemBgHover": "#ebf3ff",
  "controlItemBgActive": "#c7daff",
  "controlItemBgActiveHover": "#adc9ff",
  "controlInteractiveSize": 16,
  "controlItemBgActiveDisabled": "rgba(46, 46, 46, 0.08)",
  "controlTmpOutline": "rgba(46, 46, 46, 0.02)",
  "opacityLoading": 0.65,
  "padding": 16,
  "paddingXXS": 4,
  "paddingXS": 8,
  "paddingSM": 12,
  "paddingMD": 20,
  "paddingLG": 24,
  "paddingXL": 32,
  "paddingXXL": 40,
  "padding3XL": 48,
  "padding4XL": 56,
  "padding5XL": 64,
  "margin": 16,
  "marginXXS": 4,
  "marginXS": 8,
  "marginSM": 12,
  "marginMD": 20,
  "marginLG": 24,
  "marginXL": 32,
  "marginXXL": 40,
  "margin3XL": 48,
  "margin4XL": 56,
  "margin5XL": 64,
  "controlPaddingHorizontal": 12,
  "controlPaddingHorizontalSM": 8,
  "paddingContentHorizontalLG": 24,
  "paddingContentVerticalLG": 16,
  "paddingContentHorizontal": 16,
  "paddingContentVertical": 12,
  "paddingContentHorizontalSM": 16,
  "paddingContentVerticalSM": 8,
  "boxShadow": "0px 1px 2px 0px rgba(0, 0, 0, 0.03), 0px 1px 6px -1px rgba(0, 0, 0, 0.02), 0px 2px 4px 0px rgba(0, 0, 0, 0.02)",
  "boxShadowSecondary": "0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 9px 28px 8px rgba(0, 0, 0, 0.05)",
  "boxShadowCard": "0px 1px 2px -2px rgba(0, 0, 0, 0.16), 0px 3px 6px 0px rgba(0, 0, 0, 0.12), 0px 5px 12px 4px rgba(0, 0, 0, 0.09)",
  "colorItemText": "rgba(253, 254, 255, 0.65)",
  "colorItemTextDisabled": "rgba(253, 254, 255, 0.25)",
  "focusPrimary": "0px 0px 0px 2px rgb(0, 0, 0)",
  "focusError": "0px 0px 0px 2px rgb(0, 0, 0)",
  "focusWarning": "0px 0px 0px 2px rgb(0, 0, 0)",
  "tooltipBg": "#2e2e2e",
  "segmentedBgColorSelected": "#fdfeff",
  "segmentedGroupBg": "rgba(46, 46, 46, 0.08)",
  "colorMenuDarkBg": "#001529",
  "colorMenuSubItemBg": "#000c17",
  "boxShadowButtonSolid": "0px 2px 0px 0px rgb(0, 0, 0)",
  "paddingTooltipContentVertical": 6,
  "fontSizeSM": 12,
  "fontSizeLG": 16,
  "fontSizeXL": 18,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 32,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 22,
  "fontSizeHeading5": 20,
  "next": {
    "controlHeight": "28px",
    "controlHeightLG": "32px",
    "controlHeightSM": "22px",
    "borderRadius": "6px",
    "boxShadow": "0px 2px 4px 0px #00000005, 0px 1px 6px -1px #00000005, 0px 1px 2px 0px #00000008",
    "colorBorder": "#EBEEF1",
    "colorBorderHover": "#B6C0CD",
    "colorBorderFocus": "#105ED5",
    "boxShadowHover": "0px 0px 0px 2px #B6C0CD33",
    "boxShadowFocus": "0px 0px 0px 2px #105ED526",
    "boxShadowFocusGreen": "0px 0px 0px 2px #02BB7F26",
    "colorBgField": "#FFFFFF",
    "colorBgDisabled": "#FAFBFC",
    "colorBgOptionActive": "#F5F6F8",
    "colorText": "#353A44",
    "colorTextPlaceholder": "#99A5B8",
    "colorError": "#A4243E",
    "boxShadowError": "0px 0px 0px 2px #A4243E26",
    "fontSize100": "13px",
    "fontSize200": "14px",
    "fontWeight400": 400,
    "fontWeight500": 500,
    "fontWeight600": 600,
    "palette": {
      "grey0": "#FFFFFF",
      "grey25": "#FAFBFC",
      "grey50": "#F5F6F8",
      "grey75": "#EBEEF1",
      "grey100": "#D8DEE4",
      "grey200": "#B6C0CD",
      "grey300": "#99A5B8",
      "grey400": "#818DA0",
      "grey500": "#6C7688",
      "grey600": "#596171",
      "grey700": "#474E5A",
      "grey800": "#353A44",
      "grey900": "#21252C",
      "blue50": "#EBF3FD",
      "blue500": "#105ED5",
      "red50": "#FDF5FA",
      "red100": "#F7CEDE",
      "red500": "#A4243E",
      "amber50": "#FFF6EB",
      "amber100": "#FEE1C9",
      "amber500": "#C2410C",
      "green50": "#E6F8F1",
      "green500": "#02BB7F",
      "green525": "#02AB6F",
      "lime50": "#EFFEDA",
      "lime100": "#B5E98F",
      "lime700": "#2C671D",
      "lilac50": "#ECE6FF",
      "mint50": "#C7F5D3",
      "peach50": "#FFE8DC"
    },
    "tagSelect": {
      "colorTagBackground": "#FDF3CA",
      "colorTagBorder": "#EFE4B4",
      "colorTagText": "#353A44",
      "colorTagChipBg": "#F5F6F8",
      "colorTagChipBorder": "#EBEEF1",
      "colorTagChipText": "#474E5A",
      "colorTagChipXHover": "#000"
    },
    "identity": {
      "iconFg": "#21252C",
      "entityBg": "#ECE6FF",
      "eventBg": "#C7F5D3",
      "audienceBg": "#FFE8DC",
      "relationBg": "#ECE6FF",
      "brandBlue": "#105ED5",
      "aiGradientStart": "#1AB6E5",
      "aiGradientMid": "#1A5EE5",
      "aiGradientEnd": "#6B1AE5",
      "logoPlateBg": "#FFFFFF",
      "logoPlateInset": "#1A1C2073"
    },
    "sourceCategory": {
      "text": "#21252C",
      "event": "#CDBFF9",
      "extract": "#A7E6D7",
      "retl": "#C7DAFF",
      "retlText": "#FFFFFF",
      "retlAudience": "#FF7A45",
      "retlTable": "#C41D7F",
      "retlModel": "#7447FC"
    }
  }
}
